import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getHistorialPagos } from "../api";
import "../assets/css/style.css";
import { motion, AnimatePresence } from "framer-motion";
import { useDynamicSplash } from "../hooks/useDynamicSplash";

const Pagos = () => {
  const [pagos, setPagos] = useState([]);
  const [loading, setLoading] = useState(false);
  const showSplash = useDynamicSplash(loading);
  const navigate = useNavigate();
  const id_perfil = localStorage.getItem("id_perfil");

  // Reescribir historial para que swipe-back regrese a /perfil
  useEffect(() => {
    window.history.replaceState({}, "", "/perfil");
    window.history.pushState({}, "", "/historialpagos");
  }, []);

  useEffect(() => {
    let mounted = true;

    const cargarPagos = async () => {
      setLoading(true);
      document.body.style.overflow = "hidden";

      try {
        const data = await getHistorialPagos(id_perfil);
        if (!mounted) return;
        setPagos(data || []);
      } finally {
        if (mounted) {
          setLoading(false);
          document.body.style.overflow = "auto";
          window.scrollTo(0, 0);
        }
      }
    };

    if (id_perfil) {
      cargarPagos();
    }
    return () => {
      mounted = false;
      document.body.style.overflow = "auto";
    };
  }, [id_perfil]);

  return (
    <>
      {showSplash && (
        <div id="splash">
          <img src="/assets/images/loading.gif" style={{ width: 300 }} alt="Cargando..." />
        </div>
      )}
      {!showSplash && (
       <motion.div
	      initial={{ y: "100%", opacity: 0 }}
	      animate={{ y: 0, opacity: 1 }}
	      exit={{ y: "100%", opacity: 0 }}
	      transition={{ duration: 0.7, ease: "easeInOut" }}
    	>
    <div className="app-container">
      <div className="connections-container">
        <div className="back-container">
          <button className="back-btn" onClick={() => navigate("/perfil")}>
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 512 512">
              <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="48" d="M244 400L100 256l144-144M120 256h292"/>
            </svg>
          </button>
        </div>
        <h2 className="connections-title">Historial de pagos</h2>
      </div>

      <div className="feature-list">
        {pagos.length > 0 ? (
          pagos.map((pago, index) => (
            <div className="feature-item" key={index} style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <div className="icon" style={{background:'#eee'}}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 20 20"><path fill="currentColor" d="M13.5 13a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1zM2 6.75A2.75 2.75 0 0 1 4.75 4h10.5A2.75 2.75 0 0 1 18 6.75v6.5A2.75 2.75 0 0 1 15.25 16H4.75A2.75 2.75 0 0 1 2 13.25zM4.75 5A1.75 1.75 0 0 0 3 6.75V8h14V6.75A1.75 1.75 0 0 0 15.25 5zM17 9H3v4.25c0 .966.784 1.75 1.75 1.75h10.5A1.75 1.75 0 0 0 17 13.25z"/></svg>
                    </div>
                    <div className="feature-text" style={{ lineHeight: 1.4 }}>
                    <h3 style={{ marginBottom: 0 }}>{pago.tipo}</h3>
                    <p style={{ fontSize: 14, marginTop: 2 }}>{new Date(pago.fecha_pago).toLocaleDateString("es-GT", { year: "numeric", month: "long", day: "numeric" })}</p>
                    </div>
                </div>
                <div style={{ fontWeight: "bold", fontSize: "16px" }}>
                    Q{parseFloat(pago.monto).toFixed(2)}
                </div>
                </div>
          ))
        ) : (
          <div className="no-data-wrapper" style={{height:300, marginTop:95}}>
            <div className="no-data">
              <img src="/assets/images/empty.svg" alt="Sin referidos" />
              <p>
                Aún no has realizado ninguna transacción.
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
    </motion.div>
    )}
    </>
  );
};

export default Pagos;
